<template>
  <v-container fluid>

    <v-row justify="center">
      <v-col cols="12">
        <h1>{{$t("message.group.accountEntry.title.detail")}}</h1>
      </v-col>
    </v-row>

    <v-row justify="center" v-if="view.errors.length > 0">
      <v-col cols="12">
        <mp-error :errors="view.errors" message-key="message.group.accountEntry.error." />
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{$t("message.group.accountEntry.label.detail.mailAddress")}}</mp-label>
      </v-col>
      <v-col cols="8" outlined tile>
        <mp-input-box>{{ view.mailAddress }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{$t("message.group.accountEntry.label.detail.name")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.name }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{$t("message.group.accountEntry.label.detail.group")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.groupLarge.groupLargeName[$i18n.locale] }}<span class="mx-2">＞</span>{{ view.groupSmall.groupSmallName[$i18n.locale] }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{ view.groupSmall.companyLabel[$i18n.locale] }}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.companyName }}</mp-input-box>
        <mp-input-box>{{ view.companyNameKana }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{ view.groupSmall.branchLabel[$i18n.locale] }}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.branchName }}</mp-input-box>
        <mp-input-box>{{ view.branchNameKana }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{$t("message.group.accountEntry.label.detail.postNo")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.postNo }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{$t("message.group.accountEntry.label.detail.prefCd")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ $store.getters.prefNameByCode(view.prefCd)[$i18n.locale] }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{$t("message.group.accountEntry.label.detail.addr1")}}</mp-label>
      </v-col>
      <v-col cols="8" dense>
        <mp-input-box>{{ view.addr1 }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{$t("message.group.accountEntry.label.detail.addr2")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.addr2 }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{$t("message.group.accountEntry.label.detail.addr3")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.addr3 }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{$t("message.group.accountEntry.label.detail.busho")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.busho }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{$t("message.group.accountEntry.label.detail.telNo")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.telNo }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{$t("message.group.accountEntry.label.detail.remarks")}}</mp-label>
      </v-col>
      <v-col cols="8" class="pr-0">
        <mp-multiple-lines-input-box>{{ view.remarks }}</mp-multiple-lines-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{$t("message.group.accountEntry.label.detail.services")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>
          <ul class="serviceList">
            <li v-for="s in view.services" :key="s.serviceId">
              {{ s.serviceName[$i18n.locale] }}
            </li>
          </ul>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col
        class="text-center"
        md="3"
        sm="4"
      >
        <mp-button wide @click="goList">{{$t("message.group.accountEntry.button.detail.back")}}</mp-button>
      </v-col>
      <v-col
        class="text-center"
        md="3"
        sm="4"
      >
        <mp-button red wide @click="dialog.rejectConfirm = true">{{$t("message.group.accountEntry.button.detail.reject")}}</mp-button>
        <mp-dialog reject confirm :show="dialog.rejectConfirm" @clickOk="goReject"
                   @clickCancel="dialog.rejectConfirm = false"/>
        <mp-dialog reject :show="dialog.rejectComplete" @clickOk="goList"/>
      </v-col>
      <v-col
        class="text-center"
        md="3"
        sm="4"
      >
        <mp-button red wide @click="dialog.approvalConfirm = true">{{$t("message.group.accountEntry.button.detail.approval")}}</mp-button>
        <mp-dialog approval confirm :show="dialog.approvalConfirm" @clickOk="goApproval"
                   @clickCancel="dialog.approvalConfirm = false"/>
        <mp-dialog approval :show="dialog.approvalComplete" @clickOk="goList"/>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import MpLabel from '@/components/item/MpLabel.vue'
import MpInputBox from '@/components/item/MpInputBox.vue'
import MpButton from '@/components/item/MpButton.vue'
import MpDialog from '@/components/item/MpDialog.vue'
import { GroupAccountEntry, Common } from '@/api'
import MpError from '@/components/item/MpError'
import StringUtils from '@/utils/StringUtil'
import MpMultipleLinesInputBox from '@/components/item/MpMultipleLinesInputBox.vue'

export default {
  name: 'top',
  components: {
    MpError,
    MpLabel,
    MpInputBox,
    MpButton,
    MpDialog,
    MpMultipleLinesInputBox
  },
  data: () => ({
    accountEntryId: null,
    view: {
      errors: [],
      accountEntryId: '',
      mailAddress: '',
      name: '',
      groupLarge: {
        groupLargeName: {
          ja: '',
          en: ''
        }
      },
      groupSmall: {
        groupSmallName: {
          ja: '',
          en: ''
        },
        companyLabel: {
          ja: '',
          en: ''
        },
        branchLabel: {
          ja: '',
          en: ''
        }
      },
      companyId: '',
      companyName: '',
      companyNameKana: '',
      branchId: '',
      branchName: '',
      branchNameKana: '',
      postNo: '',
      prefCd: '',
      addr1: '',
      addr2: '',
      addr3: '',
      busho: '',
      telNo: '',
      remarks: '',
      services: []
    },
    dialog: {
      rejectConfirm: false,
      rejectComplete: false,
      approvalConfirm: false,
      approvalComplete: false
    }
  }),
  computed: {},
  methods: {
    goList () {
      // 一覧画面に戻る
      this.$router.push({ path: '/group/account/entry/list' })
    },
    async goReject () {
      // ダイアログ非表示
      this.dialog.rejectConfirm = false

      await GroupAccountEntry.reject({ accountEntryIdList: [this.accountEntryId] })
        .then(() => { this.dialog.rejectComplete = true })
        .catch(error => { this.view.errors = error.messages })
    },
    async goApproval () {
      // ダイアログ非表示
      this.dialog.approvalConfirm = false

      await GroupAccountEntry.approve({ accountEntryIdList: [this.accountEntryId] })
        .then(() => { this.dialog.approvalComplete = true })
        .catch(error => { this.view.errors = error.messages })
    },
    async setDefaultLabel () {
      const list = await Common.labelList({ key: 'default' })
      this.view.groupSmall.companyLabel.ja = StringUtils.isEmpty(this.view.groupSmall.companyLabel.ja)
        ? this.getDefaultLabelFromList(list, 'label.default.company.ja')
        : this.view.groupSmall.companyLabel.ja

      this.view.groupSmall.companyLabel.en = StringUtils.isEmpty(this.view.groupSmall.companyLabel.en)
        ? this.getDefaultLabelFromList(list, 'label.default.company.en')
        : this.view.groupSmall.companyLabel.en

      this.view.groupSmall.branchLabel.ja = StringUtils.isEmpty(this.view.groupSmall.branchLabel.ja)
        ? this.getDefaultLabelFromList(list, 'label.default.branch.ja')
        : this.view.groupSmall.branchLabel.ja

      this.view.groupSmall.branchLabel.en = StringUtils.isEmpty(this.view.groupSmall.branchLabel.en)
        ? this.getDefaultLabelFromList(list, 'label.default.branch.en')
        : this.view.groupSmall.branchLabel.en
    },
    getDefaultLabelFromList (list, key) {
      const ele = list.find(ele => ele.configKey === key)
      if (ele === undefined || ele.configVal === undefined) {
        return ''
      }
      return ele.configVal
    }
  },
  created: async function () {
    this.view.errors = []
    // パラメータからアカウント申請IDを取得
    this.accountEntryId = this.$route.params.id

    // アカウント情報取得
    const result = await GroupAccountEntry.detail({ accountEntryId: this.accountEntryId })
      .catch(error => { this.view.errors = error.messages })
    this.view = { ...this.view, ...result }

    await this.setDefaultLabel()
  }
}
</script>

<style scoped>
</style>
